import React, { useContext } from 'react'
import './ExploreMenu.css'
import { StoreContext } from '../../context/StoreContex'
const ExploreMenu = ({ category, setCategory }) => {
  const { products, setProducts } = useContext(StoreContext)

  if (products.length === 0) {
    return <div className='explore-menu' id='explore-menu'>
      <h1>Explore Our Menu</h1>
      <p className='explore-menu-text'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam tenetur molestias vitae? Autem amet praesentium omnis veritatis beatae natus illo quae quasi, inventore perferendis earum perspiciatis alias sapiente iste vitae.</p>
      <div className='explore-menu-list'>
        <p>Loading...</p>
      </div>
    </div>
  }

  return (
    <div className='explore-menu' id='explore-menu'>
      <h1>Explore Our Menu</h1>
      <p className='explore-menu-text'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam tenetur molestias vitae? Autem amet praesentium omnis veritatis beatae natus illo quae quasi, inventore perferendis earum perspiciatis alias sapiente iste vitae.</p>
      <div className='explore-menu-list'>


      </div>

      <div className='explore-menu-list'>
        {products.catg
          .filter((categoryObj) => {
            // Check if there is at least one product that belongs to this category
            return products.menu.some((item) => item.categoryID === categoryObj._id);
          })
          .map((categoryObj) => (
            <div
              onClick={() => setCategory(prev => prev === categoryObj.catgory ? 'All' : categoryObj.catgory)}
              key={categoryObj._id}
              className='explore-menu-list-item'
            >
              <img className={category === categoryObj.catgory ? "active" : ""} src={""} alt='' />
              <p>{categoryObj.catgory}</p>
            </div>
          ))
        }
      </div>
      <hr />
    </div>
  )
}

export default ExploreMenu